import { useState, useEffect } from "react"
import { Card, CardHeader, CardContent, IconButton, Tooltip } from "@mui/material"
import { Close, Edit, Person } from '@mui/icons-material'
import EditUser from "./EditUser"

export default function UserCard(props) {
    const [edit, setEdit] = useState(!!props.user.role?.tecnico);
    const [integrator, setIntegrator] = useState(!!props.user.role?.revenda);
    const [disabled, setDisabled] = useState()

    const handleEditFinished = () => setEdit(false);

    useEffect(() => {
        const loggedId = props.loggedUser?.id;
        const cardId = props.user.id;
        const isOwnAccount = loggedId === cardId;
        const loggedRole = props.loggedUser?.role || props.loggedUser?.roles || {};
        const isFullAdmin = !!(loggedRole.upload && loggedRole.usuarios && loggedRole.alarmes &&
            loggedRole.relatorio && loggedRole.editar);
        // Pode editar se: é a própria conta OU tem todas as permissões
        setDisabled(!isOwnAccount && !isFullAdmin);
    }, [])

    return (
        <Card 
            sx={{
                background: 'linear-gradient(135deg, rgba(26,37,47,0.97) 0%, rgba(44,62,80,0.97) 100%)',
                border: `4px solid ${!!props.webMaster ? 'rgba(255,204,0,0.35)' : 'rgba(52,152,219,0.3)'}`,
                borderRadius: '16px',
                color: '#fff',
                padding: '0.5rem',
                transition: 'all 0.3s ease',
                animation: 'fadeSlideIn 0.4s ease-out',
                '&:hover': {
                    borderColor: !!props.webMaster ? 'rgba(255,204,0,0.65)' : 'rgba(52,152,219,0.65)',
                    boxShadow: !!props.webMaster ? '0 6px 18px rgba(255,204,0,0.15)' : '0 6px 18px rgba(52,152,219,0.15)',
                    transform: 'translateY(-2px)'
                },
                '@keyframes fadeSlideIn': {
                    '0%': { opacity: 0, transform: 'translateY(10px)' },
                    '100%': { opacity: 1, transform: 'translateY(0)' }
                }
            }}
        >
            <CardHeader
                avatar={<Person sx={{ color: !!props.webMaster ? '#FFCC00' : '#5ACBFA' }} />}
                action={
                    !integrator ?
                    edit
                    ?
                    <Tooltip title="Cancelar">
                        <IconButton onClick={() => setEdit(!edit)}>
                            <Close />
                        </IconButton>
                    </Tooltip>
                    :
                    <Tooltip title="Editar">
                        <IconButton disabled={disabled} onClick={() => setEdit(!edit)}>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    : null
                }
                title={!!props.webMaster ? `${props.user.dS_NOME || props.user.DS_NOME || "—"} - Master` : (props.user.dS_NOME || props.user.DS_NOME || "—")}
                titleTypographyProps={{ sx: { color: '#fff', fontWeight: 600 } }}
            />
            {edit || integrator ?
                <>
                    <CardContent>
                        <EditUser 
                            user={props.user} 
                            loggedUser={props.loggedUser}
                            removeUser={props.removeUser} 
                            onEditFinished={handleEditFinished}
                            onUserUpdated={props.onUserUpdated}
                        />
                    </CardContent>
                </>
                : null}
        </Card>
    )
}